/**
 * Check format password
 *
 * @param {string} password  - password
 * @returns {boolean}  Return true if password is correct format, false remaining case
 */
export const checkPasswordFormat = (password: string): boolean => {
  const regexPassword = /^[\x21-\x7E]*$/;
  const minCharacter = 8;
  const maxCharacter = 50;

  return Boolean(
    password && password.length >= minCharacter && password.length <= maxCharacter && regexPassword.test(password),
  );
};

/**
 * Check format email
 *
 * @param {string} email  - email
 * @returns {boolean}  Return true if email is correct format, false remaining case
 */
export const checkEmailFormat = (email: string): boolean => {
  const regexEmail =
    /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return Boolean(email && email.length && regexEmail.test(email));
};

/**
 * Check format phone number
 *
 * @param {string} phone  - phone
 * @returns {boolean}  Return true if phone is correct format, false remaining case
 */
export const checkPhoneNumberFormat = (phone: string): boolean => {
  const regexPhone = /^[\\+]?[(]?[0-9]{3}[)]?[-\s\\.]?[0-9]{3}[-\s\\.]?[0-9]{4,6}$/im;

  return Boolean(phone && phone.length && regexPhone.test(phone));
};

/**
 * remove space
 *
 * @param {string} str - string to remove
 * @return {string} string without space
 *
 */
export const removeUnnecessarySpace = (str: string): string => {
  return (str || "").replace(/\s+/g, "").trim();
};

/**
 * Determine if a variable is 'undefined' or 'null'
 */
export const isUndefinedOrNull = (value: number) => {
  return value === null || value === undefined;
};

/**
 * Check is json string
 *
 * @param {any} json - any param to check
 * @return {boolean}
 */
export const isJsonString = (json: any): boolean => {
  try {
    JSON.parse(json);
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Convert Bytes size
 * @param bytes - size file
 * @returns
 */
export const convertBytes = (bytes: number): string => {
  const kb: number = bytes / 1024;
  const mb: number = kb / 1024;
  const gb: number = mb / 1024;

  if (gb >= 1) {
    return `${gb.toFixed(2)} GB`;
  }
  if (mb >= 1) {
    return `${mb.toFixed(2)} MB`;
  }
  if (kb >= 1) {
    return `${kb.toFixed(2)} KB`;
  }
  return `${bytes} B`;
};

export const arrayBufferToFile = (arrayBuffer: ArrayBuffer, fileType: string, fileName: string): File => {
  const blob = new Blob([arrayBuffer], { type: fileType });
  const file = new File([blob], fileName, { type: fileType });
  return file;
};

export const isElectron = () => {
  if (typeof process !== "undefined" && typeof process.versions === "object" && !!process.versions.electron) {
    return true;
  }

  if (
    typeof navigator === "object" &&
    typeof navigator.userAgent === "string" &&
    navigator.userAgent.indexOf("Electron") >= 0
  ) {
    return true;
  }

  return false;
};

export const uuid = (separator = "-") => {
  return `xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx`
    .replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0,
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    })
    .replace(/-/g, separator);
};
